export default __webpack_public_path__ + "static/FReg-4x3-PhysPack-7ae70bdbd4ff26309e0faa58944d40c6.jpg";